export const SortArrows = () => (
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.89301 3.88667L11.0063 6L11.9463 5.06L8.89301 2L5.83301 5.06L6.77967 6L8.89301 3.88667ZM8.89301 12.1133L6.77967 10L5.83967 10.94L8.89301 14L11.953 10.94L11.0063 10L8.89301 12.1133Z"
      fill="#333333"
    />
  </svg>
)
